export default function last ( array ) {
	return array[ array.length - 1 ];
}
